import React from 'react';
import CreatableSelect from 'react-select/creatable';
import AsyncSelect from 'react-select/async';
import { renderIf, isSome } from 'core/utils';
import { defaultTemplate } from 'core/hoc';

const BaasicAsyncCreatableSelectTemplate = ({ t, creatable, createMode, ...props }) => {
	const AsyncComponent = props.creatable ? CreatableSelect : AsyncSelect;
	// Translate placeholder message if any
	if (props.placeholder) props.placeholder = t(props.placeholder);
	let labelHtml, errorHtml;
	if (props.field) {
		let field = props.field;
		const requiredMark =
			field.rules && field.rules.indexOf('required') !== -1 ? <span className="type--color--warning">*</span> : null;
		labelHtml = (
			<label htmlFor={field && field.id}>
				{t(field && field.label)} {requiredMark}
				{renderIf(
					field &&
						field.$rules &&
						field.$rules.includes('required') &&
						!isSome(field.error) &&
						field.$value &&
						createMode == true
				)(
					<span className="form__label--check type--color--success">
						<i className="fa fa-check-circle"></i>
					</span>
				)}
			</label>
		);
		errorHtml = renderIf(isSome(field) && isSome(field.error))(
			<p className="type--tny type--color--error">{t(field && field.error)}</p>
		);
	}
	return (
		<React.Fragment>
			{labelHtml}
			<div
				className={
					props.field &&
					props.field.$rules &&
					props.field.$rules.includes('required') &&
					!isSome(props.field.error) &&
					props.field.$value &&
					createMode == true
						? 'input__wrap--valid'
						: null
				}
			>
				<div className="input--med--dropdown">
					<AsyncComponent ref={innerProps => props.getRef && props.getRef(innerProps)} {...props} value={props.field?props.field.$value:props.value} />
				</div>
			</div>
			{errorHtml}
		</React.Fragment>
	);
};

export default defaultTemplate(BaasicAsyncCreatableSelectTemplate);
